function removeFromCart (params) {

	if (window.utag) {

		const data = {
			event_name: 'remove_from_cart',
			...params
		};

		const utagTrackingPromise = new Promise((resolve) => {

			// utag.link() returns true, or undefined if tracking is blocked
			const wasSuccessful = window.utag.link(data, () => resolve());
			if (wasSuccessful) resolve();

			// Tracking is allowed 500ms for successful resolution,
			// then we resolve the promise regardless.
			setTimeout(() => resolve(), 500);

		});

	}

}

export default removeFromCart;
